import WhatsAppPage from "./WhatsApp.page";

export default WhatsAppPage;
